/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  ConfirmParkedRideBookingModel,
  ParkedRideBookingModel,
  ParkedRideBookingsDismissParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useParkedRideBookingsGetListHook = () => {
  const parkedRideBookingsGetList =
    useCustomInstance<ParkedRideBookingModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return parkedRideBookingsGetList({
        url: `/api/ParkedRideBookings/GetList`,
        method: 'GET',
        signal,
      });
    },
    [parkedRideBookingsGetList]
  );
};

export const getParkedRideBookingsGetListQueryKey = () => {
  return [`/api/ParkedRideBookings/GetList`] as const;
};

export const useParkedRideBookingsGetListQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getParkedRideBookingsGetListQueryKey();

  const parkedRideBookingsGetList = useParkedRideBookingsGetListHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>>
  > = ({ signal }) => parkedRideBookingsGetList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ParkedRideBookingsGetListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>>
>;
export type ParkedRideBookingsGetListQueryError = unknown;

export const useParkedRideBookingsGetList = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetListHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useParkedRideBookingsGetListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useParkedRideBookingsGetCountHook = () => {
  const parkedRideBookingsGetCount = useCustomInstance<number>();

  return useCallback(
    (signal?: AbortSignal) => {
      return parkedRideBookingsGetCount({
        url: `/api/ParkedRideBookings/GetCount`,
        method: 'GET',
        signal,
      });
    },
    [parkedRideBookingsGetCount]
  );
};

export const getParkedRideBookingsGetCountQueryKey = () => {
  return [`/api/ParkedRideBookings/GetCount`] as const;
};

export const useParkedRideBookingsGetCountQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getParkedRideBookingsGetCountQueryKey();

  const parkedRideBookingsGetCount = useParkedRideBookingsGetCountHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>>
  > = ({ signal }) => parkedRideBookingsGetCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ParkedRideBookingsGetCountQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>>
>;
export type ParkedRideBookingsGetCountQueryError = unknown;

export const useParkedRideBookingsGetCount = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsGetCountHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useParkedRideBookingsGetCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useParkedRideBookingsConfirmHook = () => {
  const parkedRideBookingsConfirm = useCustomInstance<number>();

  return useCallback(
    (confirmParkedRideBookingModel: ConfirmParkedRideBookingModel) => {
      return parkedRideBookingsConfirm({
        url: `/api/ParkedRideBookings/Confirm`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: confirmParkedRideBookingModel,
      });
    },
    [parkedRideBookingsConfirm]
  );
};

export const useParkedRideBookingsConfirmMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>,
    TError,
    { data: ConfirmParkedRideBookingModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>,
  TError,
  { data: ConfirmParkedRideBookingModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const parkedRideBookingsConfirm = useParkedRideBookingsConfirmHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>,
    { data: ConfirmParkedRideBookingModel }
  > = (props) => {
    const { data } = props ?? {};

    return parkedRideBookingsConfirm(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParkedRideBookingsConfirmMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>
>;
export type ParkedRideBookingsConfirmMutationBody =
  ConfirmParkedRideBookingModel;
export type ParkedRideBookingsConfirmMutationError = unknown;

export const useParkedRideBookingsConfirm = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>,
    TError,
    { data: ConfirmParkedRideBookingModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsConfirmHook>>>,
  TError,
  { data: ConfirmParkedRideBookingModel },
  TContext
> => {
  const mutationOptions = useParkedRideBookingsConfirmMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useParkedRideBookingsDismissHook = () => {
  const parkedRideBookingsDismiss = useCustomInstance<void>();

  return useCallback(
    (params?: ParkedRideBookingsDismissParams) => {
      return parkedRideBookingsDismiss({
        url: `/api/ParkedRideBookings/Dismiss`,
        method: 'POST',
        params,
      });
    },
    [parkedRideBookingsDismiss]
  );
};

export const useParkedRideBookingsDismissMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>,
    TError,
    { params?: ParkedRideBookingsDismissParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>,
  TError,
  { params?: ParkedRideBookingsDismissParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const parkedRideBookingsDismiss = useParkedRideBookingsDismissHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>,
    { params?: ParkedRideBookingsDismissParams }
  > = (props) => {
    const { params } = props ?? {};

    return parkedRideBookingsDismiss(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ParkedRideBookingsDismissMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>
>;

export type ParkedRideBookingsDismissMutationError = unknown;

export const useParkedRideBookingsDismiss = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>,
    TError,
    { params?: ParkedRideBookingsDismissParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useParkedRideBookingsDismissHook>>>,
  TError,
  { params?: ParkedRideBookingsDismissParams },
  TContext
> => {
  const mutationOptions = useParkedRideBookingsDismissMutationOptions(options);

  return useMutation(mutationOptions);
};
